app.controller("PositionHistoryController", [
    "$scope", "$uibModal", "SysParam", "StaticData", "ConfirmModal", "$stateParams", "usSpinnerService", "$state", "Hr", "DocumentsService", "Position", "OrganizationalUnit",
    function ($scope, $uibModal, SysParam, StaticData, ConfirmModal, $stateParams, usSpinnerService, $state, Hr, DocumentsService, Position, OrganizationalUnit) {
        $scope.history = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.employee = $stateParams.employee || null;
        $scope.organization = $stateParams.organization || null;
        $scope.position = $stateParams.position || null;
        $scope.positionType = $stateParams.positionType || null;
        $scope.format = "dd-MM-yyyy";
        $scope.positionTypes = [
            {name: 'ტიპი'},
            {name: 'დაკავებული თანამდებობა', value:'POSITION'},
            {name: 'მოვალეობის შემსრულებელი', value:'ACTING'}
        ];

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        if($stateParams.employee) {
            DocumentsService.fetchEmployee($stateParams.employee).then(function (emp) {
                $scope.employee = emp;
                $scope.employee._id = $stateParams.employee;
            });
        }

        if($stateParams.organization) {
            OrganizationalUnit.getById($stateParams.organization).then(function (data) {
                $scope.organization = data
            });
        }

        if($stateParams.position) {
            Position.fetchOne($stateParams.position).then(function (data) {
                $scope.position = data
            });
        }

        $scope.getEmployees = function (query) {
            if (query.length < 2) {
                return [];
            }
            $scope.selected = false;
            return DocumentsService.staffList({query: query}).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.getUnits = function (query) {
            if (query.length < 2) {
                return [];
            }
            return OrganizationalUnit.findByQuery({query: query}).then(function (data) {
                return data;
            });
        };

        $scope.getPositions = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Position.findByQuery({query: query}).then(function (data) {
                return data;
            });
        };

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                employee: $scope.employee ? $scope.employee._id : null,
                organization: $scope.organization ? $scope.organization._id : null,
                position: $scope.position ? $scope.position._id : null,
                positionType: $scope.positionType
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            Hr.getPositionHistory({
                page: page,
                limit: $scope.itemsPerPage,
                employee: $stateParams.employee,
                organization: $stateParams.organization,
                position: $stateParams.position,
                positionType: $stateParams.positionType
            }).then(function (data) {
                $scope.history = data.data;
                $scope.history = $scope.history.map(function (rec) {
                    rec.toDate = new Date(rec.toDate).getTime();
                    return rec
                });
                usSpinnerService.stop("root");
                $scope.totalItems = data.totalCount;
                cb();
            });
        }
    }
]);
